"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var index_1 = require("@uifabric/styling/lib/index");
var owa_mail_messagead_store_1 = require("owa-mail-messagead-store");
var store_1 = require("owa-session-store/lib/store/store");
var owa_messagead_strings_1 = require("owa-strings/owa-messagead-strings");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var MessageAdListItemIconBar = /** @class */ (function (_super) {
    tslib_1.__extends(MessageAdListItemIconBar, _super);
    function MessageAdListItemIconBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openAdChoiceUrl = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            window.open(_this.props.adChoiceUrl, '_blank');
        };
        _this.removeMessageAdListHere = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            owa_mail_messagead_store_1.removeMessageAdClearList(_this.props.adId);
        };
        return _this;
    }
    MessageAdListItemIconBar.prototype.renderPropertyIcons = function () {
        var propertyIcons = [];
        if (this.props.adChoiceUrl) {
            propertyIcons.push(React.createElement("img", { src: store_1.default.packageBaseUrl + 'resources/images/adbarmetrosprite.png', className: styles.adChoiceIcon, onClick: this.openAdChoiceUrl }));
        }
        return propertyIcons;
    };
    MessageAdListItemIconBar.prototype.renderHoverIcons = function () {
        var hoverIconElements = [];
        var iconClasses = classNames(styles.icon, styles.hoverActionIcon);
        hoverIconElements.push(React.createElement("span", { className: classNames(iconClasses, index_1.getIconClassName("Delete" /* Delete */)), title: owa_messagead_strings_1.default.removeAdButtonText, onClick: this.removeMessageAdListHere }));
        return hoverIconElements;
    };
    MessageAdListItemIconBar.prototype.render = function () {
        return (React.createElement("div", { className: styles.messageAdIconBarContainer },
            this.renderHoverIcons(),
            this.renderPropertyIcons()));
    };
    return MessageAdListItemIconBar;
}(React.Component));
exports.default = MessageAdListItemIconBar;
//# sourceMappingURL=MessageAdListItemIconBar.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/MessageAdListItemIconBar.js
// module id = 3911
// module chunks = 67